module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15ummCr/tc-custom/9781609252786.jpg?1726871225731",
      "alt": "This image is the cover for the book Luminous Mind"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Luminous Mind\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this concise and practical guidebook, the authors of "), _c('i', [_vm._v("A Moment to Relax")]), _vm._v(" teaches essential techniques for meditation, focus and anxiety relief.")]), _c('br'), _c('br'), _vm._v("The definitive mental fitness manual, "), _c('i', [_vm._v("Luminous Mind")]), _vm._v(" offers a unique and uncomplicated process for engaging fully in life, feeding your soul, and releasing your mind and spirit from the bonds of stress and worry. In today’s world of overstimulation, packed schedules and media bombardment, it is more important than ever to harness the power of your mind and breath through meditation."), _c('br'), _c('br'), _vm._v("Joel and Michelle Levey have taught meditation, mental focus and stress management techniques to Navy Seals, the US Army, and countless business leaders around the world. Now they share those same techniques in "), _c('i', [_vm._v("Luminous Mind")]), _vm._v(". In what is truly an introduction to personal mastery, the Leveys demystify this spiritual practice and provide a complete overview of every kind of meditation, condensing their lifetime of learning into this remarkably useful book.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joel Levey, Michelle Levey, Joan Borysenko\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Conari Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0